import {
  API_ENDPOINT,
  type ClientApiV1CourseGiftsReceivedQueryString,
  useClientApiV1CourseGiftsReceivedQuery,
} from '../../resources/@types/courseSchema';
import useQueryOptionWithUserId from '../hooks/useQueryOptionWithUserId';

interface UseClientV1CourseGiftsReceivedQuery {
  params: ClientApiV1CourseGiftsReceivedQueryString;
  options?: Parameters<typeof useClientApiV1CourseGiftsReceivedQuery>[0]['options'];
}

export function useCourseGiftsReceivedQuery({
  params,
  options,
}: UseClientV1CourseGiftsReceivedQuery) {
  const { queryKey, url } = useQueryOptionWithUserId(
    API_ENDPOINT.CLIENT_V1_COURSE_GIFTS_RECEIVED,
    params,
  );

  return useClientApiV1CourseGiftsReceivedQuery({
    queryKey,
    url,
    options,
  });
}

export const getCourseGiftsReceivedQueryKey = (
  params: ClientApiV1CourseGiftsReceivedQueryString,
) => {
  const { queryKey } = useQueryOptionWithUserId(
    API_ENDPOINT.CLIENT_V1_COURSE_GIFTS_RECEIVED,
    params,
  );

  return queryKey;
};
